import type { Locale } from '@jotta/i18n'
import { MediamarktPrivacyES } from './MediamarktPrivacyES'
import { MediamarktPrivacyEN } from './MediamarktPrivacyEN'
import { MediamarktPrivacyFR } from './MediamarktPrivacyFR'
import { MediamarktPrivacyNL } from './MediamarktPrivacyNL'
import { ProseContainer } from '../components/ProseContainer'
import { MediamarktPrivacyDE } from './MediamarktPrivacyDE'

function MediamarktPrivacySwitch({ locale }: { locale: Locale }) {
  switch (locale) {
    case 'de':
      return <MediamarktPrivacyDE />
    case 'nl':
      return <MediamarktPrivacyNL />
    case 'fr':
      return <MediamarktPrivacyFR />
    case 'es':
      return <MediamarktPrivacyES />
    default:
      return <MediamarktPrivacyEN />
  }
}

export function MediamarktPrivacy({ locale }: { locale: Locale }) {
  return (
    <ProseContainer>
      <MediamarktPrivacySwitch locale={locale} />
    </ProseContainer>
  )
}
